document.addEventListener('DOMContentLoaded', function () {

  let userChangedRahmen = false;

  function selectBlackFrame() {
    const buttons = document.querySelectorAll('.layout-tabs.rehmen button');
    if (!buttons.length) return;

    const blackButton = buttons[0]; // 👈 schwarzer Rahmen
    if (blackButton) {
      blackButton.click();
    }
  }

  // 👉 User-Auswahl erkennen
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.layout-tabs.rehmen button');
    if (!btn) return;

    const buttons = document.querySelectorAll('.layout-tabs.rehmen button');
    const index = [...buttons].indexOf(btn);

    if (index !== 0) {
      userChangedRahmen = true;
    }
  });

  // 👉 Beim Wechsel zu "Rahmen"
  document.addEventListener('click', function (e) {
    const target = e.target.closest('button, span');
    if (!target) return;

    const text = (target.innerText || '').trim();

    if (text === 'Rahmen' || text === 'Weiter zum Rahmen') {
      setTimeout(() => {
        if (!userChangedRahmen) {
          selectBlackFrame();
        }
      }, 100);
    }
  }, true);

});